import React from "react";
import {HashLink as Link} from 'react-router-hash-link'

class Navbar extends React.Component {
    render() {
        return (
            <header className="header">
                <div className="container">
                    <nav className="navbar">
                        <Link className="logo-link" to="/">
                            <img className="navbar__img" src="./images/logo.png" alt="" title=""/>
                        </Link>
                        <div className="navbar__menu">
                            <ul className="navbar__items-list">
                                <li className="navbar__item">
                                    <Link to="/surveystudio" className="navbar__link underline"><b>SURVEY</b>STUDIO</Link>
                                </li>
                                <li className="navbar__item">
                                    <Link to="/dex" className="navbar__link underline"><b>DEX</b>:DIALER EXPRESS</Link>
                                </li>
                                {/* <li className="navbar__item">
                                    <Link to="/ip" className="navbar__link underline">IP-ТЕЛЕФОНИЯ</Link>
                                </li> */}
                                {/*<li className="navbar__item">*/}
                                {/*    <Link className="navbar__link underline" to="/#feedback">ОТЗЫВЫ</Link>*/}
                                {/*</li>*/}
                                {/*<li className="navbar__item">*/}
                                {/*    <Link className="navbar__link underline" to="/news">НОВОСТИ</Link>*/}
                                {/*</li>*/}
                                <li className="navbar__item">
                                    <Link className="navbar__link underline" to="/#call">КОНТАКТЫ</Link>
                                </li>
                            </ul>
                            <a className="telegram" href="https://t.me/s/sstdex">Мы в Telegram</a>
                        </div>
                    </nav>
                </div>
            </header>
        )
    }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/Components/Navbar.js